import type { Station } from "../domain/model.ts";

export function stationDisplayName(station: Pick<Station, "id" | "nameZh">): string {
  return station.id === "xiamen-north" || station.nameZh === "厦门北站" ? "厦门北站" : station.nameZh.replace(/站$/u, "");
}

export function locationName(locationId: string, stations: readonly Station[]): string {
  if (locationId === "houxi-depot") return "后溪车辆段";
  if (locationId === "caicuo-depot") return "蔡厝车辆段";
  if (locationId === "shetou-depot") return "社头车辆段";
  if (locationId === "binhai-depot") return "滨海停车场";
  const station = stations.find((candidate) => candidate.id === locationId);
  return station ? stationDisplayName(station) : locationId.replace(/站$/u, "");
}

export function directionArrow(direction: "up" | "down"): "▶" | "◀" {
  return direction === "up" ? "▶" : "◀";
}
